import { useCallback, useMemo } from 'react';

import { AnalyticalExaminationType } from '@dreryk/drerykweb-medical-dictionaries-api';

import {
   JustifyContent,
   Link,
   RemoveIcon,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';

import { referralTranslationKeys } from '../../../translations';

export const useAnalyticalExaminationTableConfiguration = (
   removeItem?: (item: AnalyticalExaminationType) => void
): TableColumnConfiguration<AnalyticalExaminationType>[] => {
   const configuration = useCallback((): TableColumnConfiguration<AnalyticalExaminationType>[] => {
      const optionsCell: TableColumnConfiguration<AnalyticalExaminationType> | undefined = removeItem
         ? {
              name: 'options',
              label: '',
              width: '20%',
              accessor: 'id',
              // Renderer is not a component

              renderer: (obj: ValueRendererProps<AnalyticalExaminationType, any>): JSX.Element => {
                 return <Link icon={<RemoveIcon />} onClick={() => removeItem(obj.bean)} testId={'remove'} />;
              },
              sortingDisabled: true,
              justifyContent: JustifyContent.END,
           }
         : undefined;

      const cells: TableColumnConfiguration<AnalyticalExaminationType>[] = [
         {
            label: referralTranslationKeys.analyticalExamination.chosenExaminations,
            width: removeItem ? '80%' : '100%',
            accessor: 'name',
            sortingDisabled: true,
         },
      ];
      if (optionsCell) {
         cells.push(optionsCell);
      }
      return cells;
   }, [removeItem]);

   return useMemo(configuration, [configuration]);
};
